import "src/decidim/comments/comments.component"
